import { useEffect, useRef } from 'react';

export function usePolling(condition: boolean, callback: () => void, delay: number) {
	const savedCallback = useRef(callback);
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	useEffect(() => {
		if (!condition) {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
			return;
		}
        
		savedCallback.current();

		intervalRef.current = setInterval(() => {
			savedCallback.current();
		}, delay);

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
		};
	}, [condition, delay]);
}
